import React, { useEffect, useRef, useState } from "react";
import LoadingIcon from "components/LoadingIcon/LoadingIcon";

// Custom Components
import Filter from "components/Filter";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { fetchDataFromApi } from "utils";
import { Divider } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { WORKER_MODULE_ACCESS_URL } from "configs/constants";
import { makeStyles } from "@material-ui/core/styles";
import { COMPANY_FETCH_URL } from "configs/constants";
import * as Yup from "yup";
import { useNotifyContext } from "@Components/Notify";


const filterFields = [
    {
        type: "datepicker",
        label: "User Access Date",
        name: "date",
        maxDate: new Date(),
    },
];
const filterFieldsbByPercentage = [
    {
        type: "datepicker",
        label: "User Access Date",
        name: "date",
        maxDate: new Date(),
    },
    {
        type: "reactselect",
        name: "company_id",
        label: "Company",
        proxyUrl: COMPANY_FETCH_URL,
        paginated: true,
        required: true,


    },

];


const today = new Date();
today.setDate(today.getDate() - 1);
const options = { timeZone: 'Asia/Kuala_Lumpur' };
let date = today.toLocaleDateString('en-GB', options);
date = date.split('/').reverse().join('-');

const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            func();
        } else {
            didMount.current = true;
        }
    }, deps);
};

export default function WorkerAccess() {

    const { t } = useTranslation();


    const [dateForAPI, setDateForAPI] = useState(date);
    const [dateForAPITotal, setDateForAPITotal] = useState(date);
    const [dateForAPIPercentage, setDateForAPIPercentage] = useState(date);
    const [companyForAPIPercentage, setCompanyForAPIPercentage] = useState(date);
    const [percentageAccessLoading, setPercentageAccessLoading] = useState(false);
    const [totalAccessLoading, setTotalAccessLoading] = useState(false);
    const [summary, setSummary] = useState({});
    const [filterButtonClicked, setFilterButtonClicked] = useState(false);
    const [summaryPercentage, setSummaryPercentage] = useState({});
    const filterInitialValues = {
        date: date,
    };
    const setNotify = useNotifyContext();

    const useStyles = makeStyles({
        borderedCell: {
            borderRight: "1px solid rgba(224, 224, 224, 1)",
            backgroundColor: "#fff",
            padding: "0px 22px 0px 22px",
        },
        bodyCell: {
            borderRight: "1px solid rgba(224, 224, 224, 1)",
        },
        companyCell: {
            borderRight: "1px solid rgba(224, 224, 224, 1)",
            borderBottom: "0px",
            backgroundColor: "#fff2cc",

        },
        totalCell: {
            borderRight: "1px solid rgba(224, 224, 224, 1)",
            backgroundColor: "#fff2cc",

        }
    });

    const classes = useStyles();
    const validationSchema = Yup.object({
        date: Yup.date().required("Date is required").nullable().typeError("Invalid From Last Login Date"),
        company_id: Yup.string().required("Company is required").nullable().typeError("Company is required"),

    });

    const apiCallback = (data) => {
        let results = {};
        if (data.results) {
            results["total"] = data.results;
            setTotalAccessLoading(false);
            setPercentageAccessLoading(false);
        }

        setSummary({ ...summary, ...results });
    };


    useDidMountEffect(() => {
        setTotalAccessLoading(true);
        fetchDataFromApi(
            WORKER_MODULE_ACCESS_URL + "?date=" + dateForAPI,
            apiCallback,
            false
        )
    }, [dateForAPI]);


    useDidMountEffect(() => {
        fetchDataFromApi(
            WORKER_MODULE_ACCESS_URL + "?date=" + dateForAPITotal,
            apiCallbackForTotal,
            false, {}, apiCallbackForError
        )
    }, [dateForAPITotal]);

    useDidMountEffect(() => {
        fetchDataFromApi(
            WORKER_MODULE_ACCESS_URL + "?date=" + dateForAPIPercentage + "&company=" + companyForAPIPercentage,
            apiCallbackForPercentage,
            false, {}, apiCallbackForError
        )
    }, [dateForAPIPercentage, companyForAPIPercentage]);

    const apiCallbackForError = (error) => {
        setNotify({
            isOpen: true,
            message: (error.response && error.response.data && error.response.data.message) || 'Error occurred',
            type: "error",
        });
        setTotalAccessLoading(false);
        setPercentageAccessLoading(false);
    };
    const apiCallbackForTotal = (data) => {
        let results = {};
        if (data) {
            results["total"] = data.results;
            setSummary({ ...summary, ...results });
        }
        setTotalAccessLoading(false);
    };

    const apiCallbackForPercentage = (data) => {
        let results = {};
        if (data) {
            results["total"] = data.results;
            setSummaryPercentage({ ...summaryPercentage, ...results });
        }
        setPercentageAccessLoading(false);
    };

    useEffect(() => {
        fetchDataFromApi(
            WORKER_MODULE_ACCESS_URL + "?date=" + date,
            apiCallback,
            false
        );
    }, []);


    const handleSubmitTotal = (values) => {
        setTotalAccessLoading(true);
        setDateForAPITotal(values.date);

        setTimeout(() => {
            setTotalAccessLoading(false);
        }, 1000);

    };

    const handleSubmitPercentage = (values) => {
        setPercentageAccessLoading(true);
        setDateForAPIPercentage(values.date);
        setCompanyForAPIPercentage(values.company_id);
        setFilterButtonClicked(true);



        setTimeout(() => {
            setPercentageAccessLoading(false);
        }, 1000);
    };






    return (
        <div>
            <div>
                <Filter
                    noClearButton
                    initialValues={filterInitialValues}
                    filterFields={filterFields}
                    onSubmit={handleSubmitTotal}
                />
                {summary.total ? (
                    <div>

                        <br />
                        {totalAccessLoading ? (
                            <LoadingIcon text="Loading" />
                        ) : (
                            <Paper
                                className={classes.filterPaper}
                                variant="outlined"
                                style={{ padding: "20px" }}
                            >
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Typography paragraph variant="h5" color="textPrimary">
                                        {" " + t("WORKER USER ACCESS TO ")}
                                        <span style={{ color: 'red' }}>MOBILE APP</span>
                                        {" " + t("SUMMARY (TOTAL)")}
                                    </Typography>
                                </div>
                                <Divider />
                                <br />

                                <Grid container spacing={3} alignItems="center" justify="flex-start">
                                    {summary.total.map((tableData, index) => (
                                        <Grid item xs={12} md={6} key={index}>
                                            <TableContainer component={Paper}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.borderedCell} align="center" colSpan={4}>{tableData.company?.name}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell className={classes.borderedCell}>MODULE ACCESS</TableCell>
                                                            <TableCell className={classes.borderedCell}>LOCAL</TableCell>
                                                            <TableCell className={classes.borderedCell}>FOREIGN</TableCell>
                                                            <TableCell className={classes.totalCell}>SUB TOTAL</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell className={classes.bodyCell}>
                                                                HOMEPAGE
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Homepage?.workers?.Local || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Homepage?.workers?.Foreign || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.modules?.Homepage?.sub_total || 0}
                                                            </TableCell>

                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell className={classes.bodyCell}>
                                                                EWORKER
                                                            </TableCell >
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.eWorker?.workers.Local || 0}
                                                            </TableCell >
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.eWorker?.workers.Foreign || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.modules?.eWorker?.sub_total || 0}
                                                            </TableCell>

                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell className={classes.bodyCell}>
                                                                CONTRACT
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Contract?.workers.Local || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Contract?.workers.Foreign || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.modules?.Contract?.sub_total || 0}
                                                            </TableCell>

                                                        </TableRow>
                                                        <TableRow>

                                                            <TableCell className={classes.bodyCell}>
                                                                ATTENDANCE
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Attendance?.workers?.Local || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Attendance?.workers?.Foreign || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.modules?.Attendance?.sub_total || 0}
                                                            </TableCell>

                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell className={classes.bodyCell}>
                                                                GRIEVANCE
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Griveance?.workers.Local || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Griveance?.workers.Foreign || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.modules?.Griveance?.sub_total || 0}
                                                            </TableCell>

                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell className={classes.bodyCell}>
                                                                SOS
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.SOS?.workers?.Local || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.SOS?.workers?.Foreign || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.modules?.SOS?.sub_total || 0}
                                                            </TableCell>

                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell className={classes.bodyCell}>
                                                                PRODUCTIVITY
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Productivity?.workers.Local || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.bodyCell}>
                                                                {tableData.modules?.Productivity?.workers.Foreign || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.modules?.Productivity?.sub_total || 0}
                                                            </TableCell>

                                                        </TableRow>





                                                    </TableBody>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className={classes.totalCell}>
                                                                GRAND TOTAL:
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.grand_total?.workers?.Local || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.grand_total?.workers?.Foreign || 0}
                                                            </TableCell>
                                                            <TableCell className={classes.totalCell}>
                                                                {tableData.grand_total?.sub_total || 0}
                                                            </TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Paper>
                        )}
                    </div>
                ) : null}
                <br />

                <Filter
                    noClearButton
                    initialValues={filterInitialValues}
                    filterFields={filterFieldsbByPercentage}
                    onSubmit={handleSubmitPercentage}
                    validationSchema={validationSchema}


                />

                {filterButtonClicked && summaryPercentage.total ? (
                    <div>

                        <br />
                        {percentageAccessLoading ? (
                            <LoadingIcon text="Loading" />
                        ) : (
                            <Paper
                                className={classes.filterPaper}
                                variant="outlined"
                                style={{ padding: "20px" }}
                            >
                                <div style={{ display: "flex", justifyContent: "center" }}>

                                    <Typography paragraph variant="h5" color="textPrimary">
                                        {" " + t("WORKER USER ACCESS TO ")}
                                        <span style={{ color: 'red' }}>MOBILE APP</span>
                                        {" " + t("SUMMARY (%)")}
                                    </Typography>
                                </div>
                                <Divider />
                                <TableContainer component={Paper} style={{ marginTop: 15 }} >                                    <Table className={classes.table} size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.totalCell}>COMPANY</TableCell>
                                            <TableCell className={classes.totalCell} >INFO</TableCell>
                                            <TableCell className={classes.totalCell} align="center"> ACTIVE WORKER</TableCell>
                                            <TableCell className={classes.totalCell} align="center">HOMEPAGE</TableCell>
                                            <TableCell className={classes.totalCell} align="center">EWORKER</TableCell>
                                            <TableCell className={classes.totalCell} align="center"> CONTRACT</TableCell>
                                            <TableCell className={classes.totalCell} align="center"> ATTENDANCE</TableCell>
                                            <TableCell className={classes.totalCell} align="center"> GRIEVANCE</TableCell>
                                            <TableCell className={classes.totalCell} align="center"> SOS</TableCell>
                                            <TableCell className={classes.totalCell} align="center"> PRODUCTIVITY</TableCell>
                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        <TableRow>
                                            <TableCell className={classes.companyCell}>{summaryPercentage.total.length > 0 ? null : null}</TableCell>

                                            <TableCell className={classes.bodyCell} >LOCAL WORKER</TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0]?.active ? (summaryPercentage.total[0].active?.workers?.Local || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Homepage ? (summaryPercentage.total[0].modules?.Homepage?.workers?.Local || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Eworker ? (summaryPercentage.total[0].modules?.Eworker?.workers?.Local || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Contract ? (summaryPercentage.total[0].modules?.Contract?.workers?.Local || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Attendance ? (summaryPercentage.total[0].modules?.Attendance?.workers?.Local || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Griveance ? (summaryPercentage.total[0].modules?.Griveance?.workers?.Local || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.SOS ? (summaryPercentage.total[0].modules?.SOS?.workers?.Local || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Productivity ? (summaryPercentage.total[0].modules?.Productivity?.workers?.Local || 0) : 0) : null}
                                            </TableCell>



                                        </TableRow>

                                        <TableRow>
                                            <TableCell className={classes.companyCell}>{summaryPercentage.total.length > 0 ? null : null}</TableCell>

                                            <TableCell className={classes.bodyCell}>FOREIGN WORKER</TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (
                                                    summaryPercentage.total[0].active && summaryPercentage.total[0].active.workers?.Foreign
                                                        ? summaryPercentage.total[0].active.workers.Foreign
                                                        : 0
                                                ) : null}
                                            </TableCell>

                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules.Homepage ? (summaryPercentage.total[0].modules.Homepage.workers.Foreign || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules.Eworker ? (summaryPercentage.total[0].modules.Eworker.workers.Foreign || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules.Contract ? (summaryPercentage.total[0].modules.Contract.workers.Foreign || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules.Attendance ? (summaryPercentage.total[0].modules.Attendance.workers.Foreign || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules.Griveance ? (summaryPercentage.total[0].modules.Griveance.workers.Foreign || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules.SOS ? (summaryPercentage.total[0].modules.SOS.workers.Foreign || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.bodyCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules.Productivity ? (summaryPercentage.total[0].modules.Productivity.workers.Foreign || 0) : 0) : null}
                                            </TableCell>


                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.companyCell}>{summaryPercentage.total.length > 0 ? summaryPercentage.total[0].company.name : null}</TableCell>

                                            <TableCell className={classes.totalCell}>SUB TOTAL</TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].grand_total ? (summaryPercentage.total[0].active?.sub_total || 0) : 0) : null}
                                            </TableCell>

                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Homepage ? (summaryPercentage.total[0].modules?.Homepage?.sub_total || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Eworker ? (summaryPercentage.total[0].modules?.Eworker?.sub_total || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Contract ? (summaryPercentage.total[0].modules?.Contract?.sub_total || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Attendance ? (summaryPercentage.total[0].modules?.Attendance?.sub_total || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Griveance ? (summaryPercentage.total[0].modules?.Griveance?.sub_total || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.SOS ? (summaryPercentage.total[0].modules?.SOS?.sub_total || 0) : 0) : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Productivity ? (summaryPercentage.total[0].modules?.Productivity?.sub_total || 0) : 0) : null}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.companyCell}>{summaryPercentage.total.length > 0 ? null : null}</TableCell>

                                            <TableCell className={classes.totalCell}>% LOCAL WORKER</TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].grand_total ? ((summaryPercentage.total[0].active?.percentage?.Local || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].active?.percentage?.Local || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Homepage ? ((summaryPercentage.total[0].modules?.Homepage?.percentage?.Local || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Homepage?.percentage?.Local || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Eworker ? ((summaryPercentage.total[0].modules?.Eworker?.percentage?.Local || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Eworker?.percentage?.Local || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Contract ? ((summaryPercentage.total[0].modules?.Contract?.percentage?.Local || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Contract?.percentage?.Local || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Attendance ? ((summaryPercentage.total[0].modules?.Attendance?.percentage?.Local || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Attendance?.percentage?.Local || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Griveance ? ((summaryPercentage.total[0].modules?.Griveance?.percentage?.Local || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Griveance?.percentage?.Local || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.SOS ? ((summaryPercentage.total[0].modules?.SOS?.percentage?.Local || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.SOS?.percentage?.Local || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Productivity ? ((summaryPercentage.total[0].modules?.Productivity?.percentage?.Local || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Productivity?.percentage?.Local || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>


                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.companyCell}>{summaryPercentage.total.length > 0 ? null : null}</TableCell>

                                            <TableCell className={classes.totalCell}>% FOREIGN WORKER</TableCell>

                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].grand_total ? ((summaryPercentage.total[0].active?.percentage?.Foreign || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].active?.percentage?.Foreign || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Homepage ? ((summaryPercentage.total[0].modules?.Homepage?.percentage?.Foreign || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Homepage?.percentage?.Foreign || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Eworker ? ((summaryPercentage.total[0].modules?.Eworker?.percentage?.Foreign || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Eworker?.percentage?.Foreign || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Contract ? ((summaryPercentage.total[0].modules?.Contract?.percentage?.Foreign || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Contract?.percentage?.Foreign || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Attendance ? ((summaryPercentage.total[0].modules?.Attendance?.percentage?.Foreign || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Attendance?.percentage?.Foreign || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Griveance ? ((summaryPercentage.total[0].modules?.Griveance?.percentage?.Foreign || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Griveance?.percentage?.Foreign || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.SOS ? ((summaryPercentage.total[0].modules?.SOS?.percentage?.Foreign || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.SOS?.percentage?.Foreign || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>
                                            <TableCell className={classes.totalCell}>
                                                {summaryPercentage.total.length > 0 ? (summaryPercentage.total[0].modules?.Productivity ? ((summaryPercentage.total[0].modules?.Productivity?.percentage?.Foreign || 0) === 0 ? "0.00%" : (summaryPercentage.total[0].modules?.Productivity?.percentage?.Foreign || 0).toFixed(2) + "%") : "0.00%") : null}
                                            </TableCell>

                                        </TableRow>
                                    </TableBody>
                                </Table>
                                </TableContainer>

                            </Paper>
                        )}
                    </div>

                ) : null}

            </div>
        </div>
    );
}
